import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useGoogleLogin} from '@react-oauth/google';
import axios from "axios";
import {apiPath, googleGetAccountInfo, serverToken} from '../utils/api'
import {CgSpinner} from "react-icons/cg";

function Login() {

    const navigate = useNavigate();

    const [isLoggedIn, setLoggedIn] = useState(false)

    const login = useGoogleLogin({
        onSuccess: async tokenResponse => {

            try {

                //Get Google account data
                const data = await axios.get(googleGetAccountInfo, {
                    headers: {
                        "Authorization": `Bearer ${tokenResponse.access_token}`
                    }
                })

                registerUser(data)

            } catch (err) {
                return (
                    <div className="container mx-auto h-screen flex justify-center items-center">
                        <CgSpinner className="w-8 h-8 animate-spin text-amber-400"/>
                    </div>
                );
            }
        }
    });

    //Register user in Happy Taxi server
    const registerUser = (data) => {

        const userRegisterData = {
            google_id: data.data.sub,
            name: data.data.name,
            email: data.data.email,
            photo: data.data.picture,
            firebase_token: "empty"
        };

        const headers = {
            'Authorization': serverToken,
        };

        axios.post(apiPath + '/auth', userRegisterData, {headers})
            .then(data => {
                localStorage.setItem("user", JSON.stringify(data.data.user));
                localStorage.setItem("G_ID",userRegisterData.google_id);
                setLoggedIn(true);
            })
            .catch(error => {
                navigate('/');
            });
    }

    useEffect(() => {

        let user = localStorage.getItem("user");
        if (user != null) {
            setLoggedIn(true);

            if (user.role === 'A') {
                navigate('/admin');
            } else {
                navigate('/');
            }
        }

    }, [isLoggedIn]);

    return (
        <div className=" bg-gray-100 mx-auto h-screen flex justify-center items-center">

            <div className="p-10 bg-white shadow rounded flex flex-col justify-center items-center">
                <h3 className="mb-5">Hola inicia sesión para continuar</h3>

                <button onClick={() => login()}
                        className="px-4 py-2 bg-amber-400 hover:bg-amber-300 text-white text-sm rounded-full">
                    Continuar con Google
                </button>
            </div>
        </div>
    );
}

export default Login;